import { useImperativeHandle, useRef } from 'react';
import { Textarea, TextareaProps } from '@anytag/shared-atoms';
import { RHFFieldWrapper } from './shared';
import { DefaultFieldProps } from './types';
import { useFormatRHFFieldProps } from './hooks';

export interface TextareaFieldProps<T extends string = string>
  extends DefaultFieldProps<T, string>,
    Omit<TextareaProps, 'name' | 'value' | 'title' | 'onChange' | 'onSubmit'> {
  onChangeCallback?: () => void;
}

export const TextareaField = <T extends string = string>({ className, ...props }: TextareaFieldProps<T>) => {
  const textAreaRef = useRef<HTMLTextAreaElement>(null);
  const {
    fieldRegister,
    fieldWrapperProps,
    fieldProps: { name, ref, onChange, onChangeCallback, ...restFieldProps }
  } = useFormatRHFFieldProps(props);
  useImperativeHandle(ref, () => textAreaRef.current || ({} as HTMLTextAreaElement), []);

  return (
    <RHFFieldWrapper {...fieldWrapperProps} className={className}>
      {({ hasError }) => (
        <Textarea
          {...fieldRegister}
          {...restFieldProps}
          invalid={hasError}
          ref={(ref) => {
            fieldRegister.ref(ref);
            textAreaRef.current = ref;
          }}
          onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
            onChangeCallback?.();
            onChange?.(name, e.target.value) || fieldRegister.onChange(e);
          }}
        />
      )}
    </RHFFieldWrapper>
  );
};
